import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Notes extends PureComponent {
    render() {
        let { fill } = this.props;
        fill = fill || "#bdbdbd";
        return (
            <SvgIcon {...this.props}>
                <path
                    fill={fill}
                    d="M11.5,6h3.4c0.4,0,0.7-0.5,0.4-0.8l-3.4-4.1C11.6,0.7,11,0.9,11,1.4v4.1C11,5.8,11.2,6,11.5,6z"
                />
                <path
                    fill={fill}
                    d="M15.5,8h-6C9.2,8,9,7.8,9,7.5v-7C9,0.2,8.8,0,8.5,0h-8C0.2,0,0,0.2,0,0.5v21C0,21.8,0.2,22,0.5,22h15
                    c0.3,0,0.5-0.2,0.5-0.5v-13C16,8.2,15.8,8,15.5,8z M2,2.5C2,2.2,2.2,2,2.5,2h4C6.8,2,7,2.2,7,2.5v1C7,3.8,6.8,4,6.5,4h-4
                    C2.2,4,2,3.8,2,3.5V2.5z M2,6.5C2,6.2,2.2,6,2.5,6h4C6.8,6,7,6.2,7,6.5v1C7,7.8,6.8,8,6.5,8h-4C2.2,8,2,7.8,2,7.5V6.5z M14,19.5
                    c0,0.3-0.2,0.5-0.5,0.5h-11C2.2,20,2,19.8,2,19.5v-1C2,18.2,2.2,18,2.5,18h11c0.3,0,0.5,0.2,0.5,0.5V19.5z M14,15.5
                    c0,0.3-0.2,0.5-0.5,0.5h-11C2.2,16,2,15.8,2,15.5v-1C2,14.2,2.2,14,2.5,14h11c0.3,0,0.5,0.2,0.5,0.5V15.5z M14,11.5
                    c0,0.3-0.2,0.5-0.5,0.5h-11C2.2,12,2,11.8,2,11.5v-1C2,10.2,2.2,10,2.5,10h11c0.3,0,0.5,0.2,0.5,0.5V11.5z"
                />
            </SvgIcon>
        );
    }
}

export default Notes;
